// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Barcode: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13">
            <path
                fill="currentColor"
                d="M0.5625,0 L0,0 L0,0.5625 L0,3.75 L1.125,3.75 L1.125,1.125 L3.75,1.125 L3.75,0 L0.5625,0 Z M4.5,9 L4.5,3 L3,3 L3,9 L4.5,9 Z M8.25,3 L6.75,3 L6.75,9 L8.25,9 L8.25,3 Z M10.5,3 L9,3 L9,9 L10.5,9 L10.5,3 Z M13.5,0 L12.9375,0 L9.75,0 L9.75,1.125 L12.375,1.125 L12.375,3.75 L13.5,3.75 L13.5,0.5625 L13.5,0 Z M0.5625,12 L3.75,12 L3.75,10.875 L1.125,10.875 L1.125,8.25 L0,8.25 L0,11.4375 L0,12 L0.5625,12 Z M13.5,12 L13.5,11.4375 L13.5,8.25 L12.375,8.25 L12.375,10.875 L9.75,10.875 L9.75,12 L12.9375,12 L13.5,12 Z M6,3 L5.25,3 L5.25,9 L6,9 L6,3 Z"
                transform="translate(0 .5)"
            />
        </svg>
    );
};

export default React.memo(Barcode);
